import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import * as unitFiltersApi from "../../services/unit_filters";
import Button from "../../components/Button";
import "../../styles/reviews.css";

function EditUnitFiltersPage() {
  const history = useHistory();
  const { id } = useParams();
  const [form, setForm] = useState({ name: "", filter_key: "" });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [unitFilter, setUnitFilter] = useState([]);

  useEffect(() => {
    fetchUnitFilters();
    // eslint-disable-next-line
  }, [id]);

  const fetchUnitFilters = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await unitFiltersApi.getUnitFilter(id);
      setUnitFilter(res.data);
      setForm({ name: res.data.name, filter_key: res.data.filter_key })
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const errors = {};
    if (!form.name.trim()) errors.name = "Name is required";
    if (!form.filter_key.trim()) errors.filter_key = "Filter key is required";
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length) {
      setError(Object.values(errors).join(". "));
      return;
    }
    setSaving(true);
    setError("");
    try {
      await unitFiltersApi.updateUnitFilter(id, form);
      history.push("/unit-filters");
    } catch (err) {
      setError(err.response?.data?.error || "Failed to update unit filter");
    } finally {
      setSaving(false);
    }
  };

  if (loading)
    return (
      <div className="wrapper">
        <div className="container">Loading...</div>
      </div>
    );

  return (
    <div className="wrapper">
      <div className="container" style={{ maxWidth: 600 }}>
        <Button title="Back" typeBtn="secondary" onPress={() => history.push("/unit-filters")} />
        <h2 className="mt-3 mb-3">Edit Unit Filter</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-2">
            <label>Filter Name</label>
            <input name="name" className="form-control" value={form.name} onChange={handleChange} required />
          </div>
          <div className="form-group mb-2">
            <label>Filter Key</label>
            <input name="filter_key" className="form-control" value={form.filter_key} onChange={handleChange} required />
          </div>
          {error && <div className="alert alert-danger">{error}</div>}
          <Button title={saving ? "Saving..." : "Save Changes"} type="submit" typeBtn="primary" disabled={saving} />
        </form>
      </div>
    </div>
  );
}

export default EditUnitFiltersPage;
